import React from 'react'
import Helmet from 'react-helmet'
import Slider from 'react-animated-slider'
import 'react-animated-slider/build/vertical.css'
import { Link } from 'react-router-dom'
import './style.css'
import { slidersRotationSpeed } from '../../constants'

const content = [
  { id: 1, image: '/_ima/Dev_Banner.png' },
  { id: 2, image: '/_ima/DevOps_banner-AltTxt.png' },
]

const Development = () => (
  <div className='development'>
    <Helmet title='Development' />
    <div id='content'>
      <Slider
        direction='vertical'
        autoplay={slidersRotationSpeed}
        touchDisabled
        previousButton={null}
        nextButton={null}
      >
        {content.map(item => (
          <div
            key={item.id}
            style={{ backgroundImage: `url('${item.image}')` }}
          />
        ))}
      </Slider>
      <div className='inside-content'>
        <p>
          <Link to='?our-story'>Appko </Link>
          provides highly talented software developers in a variety of models.
          Our primary focus is on talent, and creative ways of getting that talent into the hands of our customers.
          Developers that make a difference to Silicon Valley companies is our passion.
        </p>
        <img
          src='/_ima/Dev_Services_Areas.png'
          alt='Development Services Areas'
          height='160px'
        />
        <p>
          From engineering product, to developing mobile apps or web apps,
          to many different functions within engineering, IT, or even field delivery;
          Appko has a huge number of examples of bringing talent where it is needed.
        </p>
        <p>Our developers focus on a wide range of technologies and languages.  Below is but a few:</p>
        <ul>
          <li>Java and Scala</li>
          <li>JavaScript, Web, and JS frameworks like React and Angular</li>
          <li>Mobile for both Apple and Android</li>
          <li>Cloud Automation Solutions</li>
          <li>Big Data</li>
        </ul>
        <p>
          Appko also has a key focus area on Development Operations.
          As most of our staff work in engineering, those departments that support development have naturally
          become a priority for our talent acquisition.
        </p>
        <img
          src='/_ima/Development_Operations.png'
          alt='Development_Operations'
          height='160px'
        />
        <p>Our consultants cover a wide range of operations.  Below is a few examples:</p>
        <ul>
          <li>Build and Release</li>
          <li>Cloud Computing</li>
          <li>QA and Refractering</li>
          <li>Test Automation</li>
        </ul>
        <img
          src='/_ima/Technology_for_Services_Page.png'
          alt='Technology'
        />
        <p>
          <Link to='?our-story'>Appko </Link>
          has deep ties to
          <Link to='?Appko_and_CIS'> Eastern Europe</Link>
          .
          We have offices and legal structures there which enable us to bring talent from there into the USA.
          While we will find talent everywhere, and also offer local US-Based consulting,
          we specialize in bring talent from CIS into Silicon Valley.
        </p>
        <img
          src='/_ima/CIS.jpg'
          alt='Commonwealth of Independent States'
        />
        <p>
          Our customers have a variety of needs and work in different ways depending on the area.
          Off-Site model can deliver cost saving while keeping a highly talented developer engaged and happy.
          On-Site is often required based on the type of development being done.
          A mix where the developer starts work within the team on site for a few months,
          but then migrates to a remote member once they have a handle on the code they’re developing.
        </p>
        <img
          src='/_ima/Delivery_Model.png'
          alt='Delivery Model'
        />
        <span>
          <b>OFF-SITE</b>
          Developers work from the Appko Kyiv Ukraine office
          <ul>
            <li>offsets well with US working hours</li>
            <li>administrative issues on our side</li>
            <li>very low time for recruiting (~2-3 weeks)</li>
          </ul>
        </span>
        <span>
          <b>OFF-SITE / ON-SITE</b>
          Developers begin their assignment remotely until they obtain a Visa and come onsite
          <ul>
            <li>fully controlled development</li>
            <li>time spent on recruiting is ~ 2-4 weeks</li>
            <li>
              Appko takes care of all the onsite logistics so you can focus on software development
              and we’ll take care of Visas, airlines, logistics, car rental etc. All included in the bill rate.
              The developers show up on-site ready to join your team
            </li>
          </ul>
        </span>
        <span>
          <b>ON-SITE</b>
          Resources work from the Client’s facilities
          <ul>
            <li>higher cost due to working wages differences</li>
            <li>time spent on recruiting is higher (~4-6 weeks)</li>
          </ul>
        </span>
        <p>
          <Link to='?our-story'>Appko </Link>
          also provides flexibility in our cooperation model as well.
          We offer many different terms for working with our talented people.
          From simple time and material, to fixed price models,
          we even offer staff augmentation where our people become your people.
        </p>
        <img
          src='/_ima/Coopereation_Model.png'
          alt='Coopereation Model'
        />
        <span>
          <b>TIME & MATERIAL</b>
          <ul>
            <li>if there is no whole vision of the final product</li>
            <li>if more direct control over the process is needed</li>
            <li>fully negotiable and can use an hourly/daily/weekly/monthly rate for the amount of work</li>
            <li>high level of flexibility</li>
          </ul>
        </span>
        <span>
          <b>FIXED PRICE</b>
          <ul>
            <li>if there are well-defined specifications and precise deliverables from the start</li>
            <li>cost and timeframe are specified before the beginning of the work on project</li>
            <li>little supervision is required</li>
            <li>no flexibility</li>
          </ul>
        </span>
        <span>
          <b>STAFF AUGMENTATION</b>
          <ul>
            <li>complete control over the motivation and management of dedicated team members</li>
            <li>
              developers work as a part of the Client’s infrastructure, shares the same perspective on
              the project methodologies and is very interested in achieving company’s business goals
            </li>
            <li>Appko handles the administrative issues</li>
            <li>Client saves on training the present staff, because he brings in skilled people from outside</li>
          </ul>
        </span>
        <p>
          Appko Global has legal entities across USA and CIS, and has offices in Silicon Valley and Kyiv.
          Our Kyiv office is dedicated to finding the top talent in the world:
        </p>
        <img
          src='/_ima/talent-acquisition.png'
          alt='Talent Acquisition'
        />
      </div>
    </div>
  </div>
)

export default Development
